


const domain = 'https://hivicareapi.tallen.tech/public/api/patient/';

const verifyEmailUrl = 'public/api/patient/email/verify/:id/:token';


const patientConstants = {

    api_domain: domain,
    verifyEmailUrl
}


export default patientConstants;
